import React from "react";
import ChantContainer from "../../../CommonComponents/ChantContainer";
import ScreenHeader from "../../../CommonComponents/ScreenHeader";
import ParentAdminMemberFilters from "./ParentAdminMemberFilters/ParentAdminMemberFilters";
import { sortObjectByString } from "../../../utils/helper";
import ProfilePic from "../../../CommonComponents/ProfilePic/ProfilePic";
import ChantButton from "../../../CommonComponents/ChantButton/ChantButton";
import { Table } from "antd";
import UpdateRoleModal from "./UpdateRoleModal";
import useParentAdminMembers from "./useParentAdminMembers";

const ParentAdminMembers = () => {
  const {
    // Data
    filteredMembersList,
    isLoading,
    groupNameOptions,
    headerText,
    groupId,

    // State
    filters,
    roleChanges,
    isModalVisible,
    isSaving,

    // Handlers
    handleFilterChange,
    removeChange,
    handleSaveChanges,
    setIsModalVisible,
  } = useParentAdminMembers();

  const columns = [
    // {
    //   title: "Role",
    //   width: 200,
    //   render: (data) => {
    //     // const changeKey = data.key || `${data.email}-${data.groupName}`;
    //     // const currentValue = roleChanges[changeKey]?.newRole || data.userRole;

    //     // return (
    //     //   <ChantSelect
    //     //     value={currentValue}
    //     //     name="userRole"
    //     //     placeholder="Select Role"
    //     //     disabled={isSaving}
    //     //     onChange={(value) => handleRoleChange(data, value)}
    //     //     options={ROLES}
    //     //     style={{ width: "100%" }}
    //     //   />
    //     // );
    //   },
    // },
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => sortObjectByString(a, b, "name"),
      render: (name, record) => {
        let userRole = record.userRole || "";

        return (
          <div className="d-flex">
            <ProfilePic name={name} image={record.profileImage} />

            <div className="d-flex gap-2 justify-content-between w-100">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ marginLeft: 20, fontWeight: "bold" }}>
                  {record.name}
                </span>
                <span style={{ marginLeft: 20, fontSize: 14 }}>
                  {record.title || ""}
                </span>
                <span style={{ marginLeft: 20, fontSize: 14 }}>{userRole}</span>
              </div>
            </div>
          </div>
        );
      },
      width: window.screen.width > 500 ? 300 : 150,
    },
    {
      title: "Email",
      width: 300,
      className: "header-white",
      key: "email",
      dataIndex: "email",
      render: (email) => <span>{email}</span>,
    },
    {
      title: "Group",
      width: 200,
      key: "groupName",
      className: "header-white",
      dataIndex: "groupName",
      render: (groupName) => <span>{groupName}</span>,
    },
    {
      title: "Member since",
      width: 200,
      key: "memberSince",
      className: "header-white",
      dataIndex: "memberSince",
      // sorter: true,
      render: (memberSince) => <span>{memberSince}</span>,
    },
  ];

  return (
    <ChantContainer>
      <ScreenHeader
        title={headerText}
        elementCount={filteredMembersList?.length}
        actions={
          Object.keys(roleChanges).length > 0 ? (
            <ChantButton
              type="primary"
              onClick={() => setIsModalVisible(true)}
              disabled={isSaving}
            >
              Save Changes ({Object.keys(roleChanges).length})
            </ChantButton>
          ) : null
        }
      />
      <ParentAdminMemberFilters
        hideGroupSelection={groupId}
        filters={filters}
        handleFilterChange={handleFilterChange}
        groupNameOptions={groupNameOptions}
      />
      <Table
        bordered
        columns={columns}
        headerBorderRadius={0}
        loading={isLoading}
        dataSource={filteredMembersList}
        expandable={{ childrenColumnName: "__children__" }}
        sticky={{
          offsetHeader: 0,
          getContainer: () => document.body,
        }}
        scroll={{ x: "max-content" }}
        rowKey="key"
        bodyStyle={{
          fontSize: window.screen.width > 500 ? "18px" : "12px",
          backgroundColor: "#ffffff",
        }}
        pagination={{
          defaultPageSize: 100,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50, 100],
          position: ["bottomLeft"],
          handleOnSinglePage: true,
        }}
      />

      <UpdateRoleModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        isSaving={isSaving}
        roleChanges={roleChanges}
        removeChange={removeChange}
        handleSaveChanges={handleSaveChanges}
      />
    </ChantContainer>
  );
};

export default ParentAdminMembers;
